import { useApi } from '@/api';
import { ChartTimeFilter } from '@/components';
import {
  Card,
  DisplaySwitch,
  EmptyBox,
  ChartSkeleton,
  Flex
} from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import AssetLiquidationsGraph, { AssetData } from './AssetLiquidationsGraph';
import DatesLiquidationsGraph, { DatesData } from './DatesLiquidationsGraph';
import CollateralAssetLiquidationsGraph, {
  CollateralAssetData
} from './CollateralAssetLiquidationsGraph';
import { useSearchParams } from '@/hooks';
import _ from 'lodash';

export default function HistoricTabs() {
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const [activeDisplayOption, setActiveDisplayOption] = useSearchParams(
    'tab',
    'date'
  );
  const displayOptions = useMemo(
    () => [
      { key: 'date', value: 'Liquidations' },
      { key: 'debt', value: 'Debt Repaid' },
      { key: 'collateral', value: 'Liquidated Collateral' }
    ],
    []
  );

  const [data, error] = useApi<AssetData[] | CollateralAssetData[] | DatesData>(
    {
      url: '/liquidations/historic/',
      queryParams: {
        days_ago: chartDaysAgo,
        type: activeDisplayOption
      }
    }
  );

  if (error) {
    throw error;
  }

  if (!data) {
    return <ChartSkeleton />;
  }

  let content = undefined;
  if (_.isEmpty(data)) {
    content = <EmptyBox />;
  }
  if (activeDisplayOption === 'debt') {
    content = <AssetLiquidationsGraph data={data as AssetData[]} />;
  } else if (activeDisplayOption === 'collateral') {
    content = (
      <CollateralAssetLiquidationsGraph data={data as CollateralAssetData[]} />
    );
  } else {
    content = (
      <DatesLiquidationsGraph
        data={data as DatesData}
        chartDaysAgo={chartDaysAgo}
      />
    );
  }

  return (
    <Card flexDirection="column" gap="xs">
      <Flex
        justifyContent="space-between"
        alignItems={['center', 'flex-start']}
        flexDirection={['column', 'row']}
        gap={['xs', 'm']}>
        <DisplaySwitch
          data={displayOptions}
          activeOption={activeDisplayOption}
          onChange={setActiveDisplayOption}
        />
        <ChartTimeFilter
          activeOption={chartDaysAgo}
          onChange={setChartDaysAgo}
        />
      </Flex>
      {content}
    </Card>
  );
}
